
define('ldsh!modules/editor/templates/property_boxes/html_content', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-modal-content ed-opt-content ed-tab-content active">\n    <button class="ed-btn-hero js-request-content" data-i18n="common.editText"></button>\n</div>\n';

}
return __p
};});

